import {
  getAll,
  getPage,
  getDetail,
} from '@/api/cpuminutelyserv'

export default {
  state: {
    state_CpuMinutely_GetAllResult: null,
    state_CpuMinutely_GetPageResult: null,
    state_CpuMinutely_GetDetailResult: null,
  },
  mutations: {
    SET_CPUMINUTELY_GETALL_RESULT: (state, rst) => {
      state.state_CpuMinutely_GetAllResult = rst;
    },
    SET_CPUMINUTELY_GETPAGE_RESULT: (state, rst) => {
      state.state_CpuMinutely_GetPageResult = rst;
    },
    SET_CPUMINUTELY_GETDETAIL_RESULT: (state, rst) => {
      state.state_CpuMinutely_GetDetailResult = rst;
    },
  },
  actions: {
    CpuMinutelyServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_CPUMINUTELY_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_CPUMINUTELY_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    CpuMinutelyServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_CPUMINUTELY_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_CPUMINUTELY_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    CpuMinutelyServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_CPUMINUTELY_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_CPUMINUTELY_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_CpuMinutely_GetAllResult: state => {
      return state.state_CpuMinutely_GetAllResult;
    },
    get_CpuMinutely_GetPageResult: state => {
      return state.state_CpuMinutely_GetPageResult;
    },
    get_CpuMinutely_GetDetailResult: state => {
      return state.state_CpuMinutely_GetDetailResult;
    },
  }
}